import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding:0 ;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background: #fafafa !important;
    color: #333 !important;
    -webkit-font-smoothing: antialiased !important;
  }

  body, input, button {
    font-family: Roboto, sans-serif !important;
    font-size: 16px !important;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }
`;
